// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".export-modal[data-v-7b649b8a] .el-dialog__body {\n  background: #f7f7f8;\n  padding: 20px;\n}\n.export-modal[data-v-7b649b8a] .el-col {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
